<template>
  <div class="diagram-panel">
    <h2 class="diagram-panel__caption">
      {{ title }}
    </h2>
    <div class="diagram-panel__group">
      <doughnut-dashboard
        v-if="type === 'doughnut'"
        v-bind:item-label-key="itemLabelKey"
        v-bind:item-value-key="itemValueKey"
        v-bind:items="items"
        v-bind:options="options"
        v-bind:plugins="plugins"
      />
      <bar-dashboard
        v-if="type === 'bar'"
        v-bind:item-label-key="itemLabelKey"
        v-bind:item-value-key="itemValueKey"
        v-bind:items="items"
        v-bind:options="options"
        v-bind:plugins="plugins"
      />
      <diagram-legend
        v-if="shownLegend"
        v-bind:items="items"
      />
    </div>
    <router-link v-if="areReportsAvailable" class="diagram-panel__link" v-bind:to="navigationToReport">Перейти в отчет</router-link>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
} from 'chart.js';
import BarDashboard from '@/components/BarDashboard.vue';
import DiagramLegend from '@/components/DiagramLegend.vue';
import DoughnutDashboard from '@/components/DoughnutDashboard.vue';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
);

/**
 * @description Панель отображения диаграмм
 */
export default {
  components: {
    DoughnutDashboard,
    DiagramLegend,
    BarDashboard,
  },
  name: 'DiagramPanel',
  computed: {
    /**
     * @description Доступны ли пользователю отчеты
     * @type {boolean}
     */
    areReportsAvailable() {
      return this.$store.getters.isSectionAvailable('reports');
    },
  },
  props: {
    /**
     * @description Ключ метки элемента
     * @type {string}
     */
    itemLabelKey: {
      default: () => 'label',
      type: String,
    },
    /**
     * @description Ключ значения элемента
     * @type {string}
     */
    itemValueKey: {
      default: () => 'value',
      type: String,
    },
    /**
     * @description Название диаграммы
     * @type {String}
     */
    title: {
      required: true,
      type: String,
    },
    /**
     * @description Навигация перехода к полному отчету
     * @type {Object}
     */
    navigationToReport: {
      required: true,
      type: Object,
    },
    /**
     * @description Тип диаграммы
     * @type {string}
     */
    type: {
      required: true,
      type: String,
    },
    /**
     * @description Опции
     * @type {Object}
     */
    options: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Элементы диаграммы
     * @type {Array}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * @description Плагины
     * @type {Object}
     */
    plugins: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Отображать легенду
     * @type {boolean}
     */
    shownLegend: {
      default: () => false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
.diagram-panel {
  display: flex;
  flex-direction: column;
  gap: 35px;
  background: #F2F5F8;
  padding: 22px 28px 28px 24px;
  &__caption {
    color: #192A3E;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  &__group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
  }
  &__link {
    display: flex;
    align-items: center;
    margin: auto 0 0 auto;
    color: #0489E0;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-decoration: none;
    &:after {
      content: '';
      background-image: url("@/assets/img/arrow/arrow-next-blue.svg");
      background-size: contain;
      background-position: center;
      width: 14px;
      height: 14px;
      margin: 0 0 0 6px;
    }
    &:hover {
      text-decoration: underline;
    }
  }
}
@media screen and (max-width: 1500px) {
  .diagram-panel {
    &__group {
      flex-direction: column;
    }
  }
}
@media screen and (max-width: 480px) {
  .diagram-panel {
    &__group {
      padding: 22px 10px;
      gap: 15px;
    }
  }
}
</style>
